import { environment } from './../environments/environment';
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NbEvaIconsModule } from '@nebular/eva-icons';



import { MenuCommonService } from './services/shared/menu-common.service';
import { ToasterService } from 'angular2-toaster';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {  RequestInterceptor, 
          SmarthubServicesModule, 
          SmarthubCoreAccountPageModule,
          SmarthubCoreMiscellaneousPageModule,
          SmarthubCoreAuthenticatorPageModule,
           } from 'smarthub-core';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    NbEvaIconsModule,
		SmarthubCoreAccountPageModule.forRoot(),
		SmarthubServicesModule.forRoot(environment),
		SmarthubCoreMiscellaneousPageModule,
    SmarthubCoreAuthenticatorPageModule,
    
  
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    MenuCommonService,
    /*
    AuthGuard,
    RestService,
    NotificationService,
    */
    ToasterService,
    MenuCommonService,
  ],
})
export class AppModule {}
